import styles from './Footer.module.css'
function Footer() {
    return (
        <section className={styles.footer}>
            <p>2023 © Design por Alura. Desenvolvido por Giselle Schwab | Projeto fictício sem fins comerciais</p>
        </section>
    )
}

export default Footer;
